import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

let client = null;

export const getSupabaseClient = () => {
    if (!supabaseUrl || !supabaseAnonKey) {
        return null;
    }

    if (client) {
        return client;
    }

    client = createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            storageKey: 'sport-connections-auth',
        },
    });

    return client;
};
